module.exports = __webpack_public_path__ + "img/temperature.1467f953.png";